export default "__VITE_ASSET__BSkOgqxh__"